import {CustomError} from "../../shared/errors/CustomErrors";
import {Option} from "../../shared/utilities/OptionT";
import {APIDao, Requester} from "../APIRequester";
import {PRODUCT_SALES_API_PREFIX} from "../../common/constants";
import {ProductSalesReport, ProductSalesReportParams} from "../../shared/entities/Order/ProductSales";

export class ProductSalesRepository {
    private dao: Requester;

    constructor(dao: Requester) {
        this.dao = dao;
    }

    public async report(params: ProductSalesReportParams): Promise<Option<ProductSalesReport>> {
        return await this.dao
            .getRequest<ProductSalesReport>(`${PRODUCT_SALES_API_PREFIX}/report`, {params})
            .then((res) => ({Some: res.data}))
            .catch((err: CustomError) => ({
                Some: {
                    items: [],
                    count: 0,
                    totalQuantitySold: 0,
                    totalDistinctOrders: 0,
                    totalAmount: 0,
                },
                None: err,
            }));
    }
}

export const ProductSalesRepositoryInstance = new ProductSalesRepository(APIDao);
